// react
import React, { useEffect, useContext } from 'react';
import useForm from 'react-hook-form';
import moment from "moment";
import { useTranslation } from 'react-i18next';
import Datetime from "react-datetime";
import logoEmagrecentro from 'assets/img/emagrecentro.png';
import logoDM2 from 'assets/img/Logo_DM2.png';

// @material-ui/icons
import Assignment from "@material-ui/icons/Assignment";
import Search_Icon from "@material-ui/icons/Search";
import { makeStyles } from '@material-ui/core/styles';
// icons
import MoneyIcon from '@material-ui/icons/AttachMoney';
import Money from '@material-ui/icons/Money';
import MoneyOffIcon from '@material-ui/icons/MoneyOff';
import AccountBalanceWalletIcon from '@material-ui/icons/AccountBalanceWallet';
import AccountBalanceIcon from '@material-ui/icons/AccountBalance';
// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import Card from "beaktShared/components/Card/Card.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import CardIcon from "beaktShared/components/Card/CardIcon.js";
import CardHeader from "beaktShared/components/Card/CardHeader.js";
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import SnackbarContent from "beaktShared/components/Snackbar/SnackbarContent.js";
import Success from "beaktShared/components/Typography/Success.js";
import Warning from "beaktShared/components/Typography/Warning.js";
import Danger from "beaktShared/components/Typography/Danger.js";
// services
import { formateDate, formateDateEN, formateMesAno, getLocale, getStringMesAno, formateDateandTime, transformValueFloattoFormated } from "beaktShared/helpers/masks";
import { UsePostApi } from "beaktShared/services/crudeApiService";
import { SessionContext } from "beaktShared/services/session";
// styles
import styles from "assets/jss/material-dashboard-pro-react/views/crudeStyle.js";
const useStyles = makeStyles(styles);

export default function RelatorioResultadoAnual() {
    // Padrão para Todas as Telas
    const { t } = useTranslation();
    const session = useContext(SessionContext);
    const { register, errors, setError, clearError, getValues } = useForm({ mode: "onBlur" });

    // Elementos de LayOut
    const classes = useStyles();
    const [notification, setNotification] = React.useState({
        show: false,
        color: 'info',
        message: ''
    });
    const showNotification = (message, color) => {
        setNotification({
            show: true,
            color: color,
            message: message
        });
        setTimeout(function () {
            setNotification(prev => ({ ...prev, show: false }));
        }, 6000);
    };

    const endPoint = 'relatorios/';
    const getEndPoint = () => {
        let endPointGet = "";
        endPointGet = endPoint + "reltelegramarecebiveis/" + session.estabelecimentoId;
        return endPointGet;
    }

    const [isLoadingList, setisLoadingList] = React.useState(false);
    const [report, setReport] = React.useState([]);
    const loadList = () => {

        let obj = {
            dataIni: dtini,
            dataFim: dtfim
        }

        setisLoadingList(true);
        const endPoint = getEndPoint();
        UsePostApi(endPoint, obj).then(result => {
            if (result.status !== 200) {
                showNotification(result.message, 'danger')
                setisLoadingList(false);
                return false;
            }
            setReport(result.data);
            setisLoadingList(false);

            return true;
        });
    }

    // Filtros
    const DataAtual = moment();
    const [dtfim, setdtfim] = React.useState(formateDateEN(moment().add(- (parseInt(moment().format("DD/MM/YYYY HH:mm").substring(0, 2)) - 1), 'day').add(1, 'month').add(-1, 'day')));
    const [dtini, setdtini] = React.useState(formateDateEN(moment(dtfim).add(-1, 'year').add(1, 'day')));

    useEffect(() => {
        loadList();
    }, []);

    const monthDiff = (dateFrom, dateTo) => {
        return dateTo.getMonth() - dateFrom.getMonth() +
            (12 * (dateTo.getFullYear() - dateFrom.getFullYear()))
    }

    // Ações 
    const changeMonth = (date) => {
        let new_dtfim = formateDateEN(moment(date).add(- (parseInt(moment(date).format("DD/MM/YYYY HH:mm").substring(0, 2)) - 1), 'day').add(1, 'month').add(-1, 'day'));
        setdtfim(new_dtfim);

        setdtini(formateDateEN(moment(new_dtfim).add(-1, 'year').add(1, 'day')));
    }
    const handleClickPesquisa = () => {
        let data = getValues();

        if (data.dtini === "") {
            setError("dtini", "required", t('label.required'))
            return false;
        }
        else
            clearError("dtini")

        if (data.dtfim === "") {
            setError("dtfim", "required", t('label.required'))
            return false;
        }
        else
            clearError("dtfim")

        loadList();
    };

    // *******************************************************************************
    // *************************** PROPRIEDADES CABEÇALHO ****************************
    // *******************************************************************************

    return (

        <div>
            {/* PESQUISA */}
            <GridContainer className="no-print">
                <GridItem xs={12}>
                    <Card>
                        <CardHeader color="primary" icon>
                            <CardIcon color="primary">
                                <Search_Icon />
                            </CardIcon>
                            <h4 className={classes.cardIconTitle}>
                                {t('label.research')}
                            </h4>
                        </CardHeader>
                        <CardBody>
                            <GridContainer>
                                <GridItem xs={12} sm={6} md={3}>
                                    <FormControl fullWidth className={classes.formControl}>
                                        <label className={errors.dtini ? "select__label select__label_error" : "select__label"}>
                                            {t('label.start_month_year') + " *"}  </label>
                                        <Datetime
                                            locale={getLocale()}
                                            dateFormat={getStringMesAno()}
                                            timeFormat={false}
                                            name="dtini"
                                            defaultValue={formateMesAno(dtini)}
                                            value={formateMesAno(dtini)}
                                            inputProps={{ name: "dtini", ref: register({ required: true }), readOnly: 'readonly' }}
                                            className={errors.dtini ? "error" : ""}
                                        />
                                        {errors.dtini && <FormHelperText className={classes.labelRootError}>
                                            <span> {errors.dtini.message} </span>
                                        </FormHelperText>}
                                    </FormControl>
                                </GridItem>
                                <GridItem xs={12} sm={6} md={3}>
                                    <FormControl fullWidth className={classes.formControl}>
                                        <label className={errors.dtfim ? "select__label select__label_error" : "select__label"}>
                                            {t('label.end_month_year') + " *"}  </label>
                                        <Datetime
                                            locale={getLocale()}
                                            dateFormat={getStringMesAno()}
                                            timeFormat={false}
                                            name="dtfim"
                                            defaultValue={formateMesAno(dtfim)}
                                            value={formateMesAno(dtfim)}
                                            onChange={date => {
                                                changeMonth(date);
                                            }}
                                            inputProps={{ name: "dtfim", ref: register({ required: true }), readOnly: 'readonly' }}
                                            className={errors.dtfim ? "error" : ""}
                                        />
                                        {errors.dtfim && <FormHelperText className={classes.labelRootError}>
                                            <span> {errors.dtfim.message} </span>
                                        </FormHelperText>}
                                    </FormControl>
                                </GridItem>
                                <GridItem xs={12} sm={6} md={2}>
                                    <Button round color="primary"
                                        onClick={e => { handleClickPesquisa() }}>
                                        {t('label.search')}
                                    </Button>
                                </GridItem>
                                {notification.show &&
                                    <div>
                                        <br />
                                        <SnackbarContent
                                            message={notification.message}
                                            color={notification.color}
                                            closeNotification={() => setNotification(prev => ({ ...prev, show: false }))}
                                            close
                                        />
                                    </div>}
                            </GridContainer>

                        </CardBody>
                    </Card>
                </GridItem>
            </GridContainer>

            {/* LISTA VENDA */}
            <GridContainer>
                <GridItem md={12} xs={12}>
                    <Card>
                        <CardHeader color="primary" icon>
                            <CardIcon color="primary">
                                <Assignment />
                            </CardIcon>
                            <h4 className={`${classes.cardIconTitle} tituloPrint`}>
                                {t('sidebar.receivables_telegram_Report')}
                            </h4>

                        </CardHeader>
                        <CardBody>
                            <div className='text-right' md={6} xs={12}>
                                <Button className="no-print" round color="primary" onClick={() => window.print()}> {t('button.print')} </Button>
                            </div>
                            <div className="allowPrint">
                                <div className="cabecalho-print">
                                    <div style={{ maxWidth: '200px', display: 'inline-block', float: 'left' }}>
                                        {
                                            session.franquiaId === 1 ? (
                                                <img src={logoEmagrecentro} style={{ maxWidth: '200px' }} />
                                            ) : session.franquiaId === 3 ? (
                                                <img src={logoDM2} style={{ maxWidth: '200px' }} />
                                            ) : (
                                                <></>
                                            )
                                        }
                                    </div>
                                    <div style={{ display: 'inline-block', float: 'right' }}>
                                        <p style={{ margin: 0 }}>Filtros: </p>
                                        <h4 style={{ margin: 0 }}>Inicio: {formateDate(dtini)} | Fim: {formateDate(dtfim)} </h4>
                                    </div>
                                </div>

                                <hr className="cabecalho-print line" />

                                <div className="allowPrint-table">
                                    <div style={{ display: 'inline-block', float: 'left' }}>
                                        <h4>Ano Base: {moment(dtini).format("YYYY")} </h4>
                                    </div>
                                    <div style={{ display: 'inline-block', float: "right" }}>
                                        <h4>Emitido por: {session.nome} - {formateDateandTime(DataAtual)}</h4>
                                    </div>
                                    <GridContainer className='cnpj_anual'>
                                        <GridItem xs={12} style={{ textAlign: 'center' }}>
                                            <div style={{ background: '#f7f7f7' }}>
                                                <h4><b>MULTIFRANQUIAS FRANCHISING</b></h4>
                                            </div>
                                        </GridItem>
                                        <GridItem xs={6} md={6}>
                                            <div style={{ display: 'inline-block', float: 'left' }}>
                                                <h4><b>UNIDADE FRANQUEADA: </b>{session.estabelecimentoDescricao} </h4>
                                            </div>
                                        </GridItem>
                                        <GridItem xs={6} md={6}>
                                            <div style={{ display: 'inline-block', float: 'right' }}>
                                                <h4><b>CNPJ: </b>{report.cnpj} </h4>
                                            </div>
                                        </GridItem>
                                        <GridItem xs={12} md={4}>
                                            <div className="cardT">
                                                <div>
                                                    <Success>
                                                        <h5> <b>{t('dashboard.total_sale_value')}
                                                        </b></h5></Success>
                                                </div>
                                                <div className="ico">
                                                    <MoneyIcon style={{ fontSize: '35px' }} />
                                                </div>
                                                <div style={{ clear: 'both' }}></div>
                                                <label>{t('label.money_symbol')} {transformValueFloattoFormated(report.totalFaturamento)} </label>

                                            </div>
                                        </GridItem>
                                        <GridItem xs={12} md={4}>
                                            <div className="cardT">
                                                <div>
                                                    <Success>
                                                        <h5><b>
                                                            {t('dashboard.total_royalties')}
                                                        </b></h5></Success>
                                                </div>
                                                <div className="ico">
                                                    <Money style={{ fontSize: '35px' }} />
                                                </div>
                                                <div style={{ clear: 'both' }}></div>
                                                <label>{t("label.money_symbol")} {transformValueFloattoFormated(report.totalRoyalties)} </label>

                                            </div>
                                        </GridItem>
                                        <GridItem xs={12} md={4}>
                                            <div className="cardT">
                                                <div>
                                                    <Danger>
                                                        <h5><b>
                                                            {t('dashboard.total_expense')}
                                                        </b></h5></Danger>
                                                </div>
                                                <div className="ico">
                                                    <MoneyOffIcon style={{ fontSize: '35px' }} />
                                                </div>
                                                <div style={{ clear: 'both' }}></div>
                                                <label>{t("label.money_symbol")} {transformValueFloattoFormated(report.totalDebitos)} </label>

                                            </div>
                                        </GridItem>
                                        <GridItem xs={12} md={6}>
                                            <div className="cardT">
                                                <div>
                                                    <Success>
                                                        <h5><b>
                                                            {t('label.opening_balance')}  - <small>{formateDate(dtini)}</small>
                                                        </b></h5></Success>
                                                </div>
                                                <div className="ico">
                                                    <AccountBalanceWalletIcon style={{ fontSize: '35px' }} />
                                                </div>
                                                <div style={{ clear: 'both' }}></div>
                                                <label>{t("label.money_symbol")} {transformValueFloattoFormated(report.saldoInicial)} </label>

                                            </div>
                                        </GridItem>
                                        <GridItem xs={12} md={6}>
                                            <div className="cardT">
                                                <div>
                                                    <Warning>
                                                        <h5><b>
                                                            {t('label.closing_balance')}    - <small>{formateDate(dtfim)}</small>
                                                        </b></h5></Warning>
                                                </div>
                                                <div className="ico">
                                                    <AccountBalanceIcon style={{ fontSize: '35px' }} />
                                                </div>
                                                <div style={{ clear: 'both' }}></div>
                                                <label>{t("label.money_symbol")} {transformValueFloattoFormated(report.saldoFinal)} </label>

                                            </div>
                                        </GridItem>
                                        <div style={{ textAlign: "center" }}>
                                            <p class="VisiblePrint">PERÍODO DE COMPETÊNCIA: {formateDate(dtini)} A {formateDate(dtfim)}</p>
                                            <hr class="VisiblePrint" style={{ width: "100%" }} />
                                            <p class="VisiblePrint" style={{ textAlign: "center" }}>** AS INFORMAÇÕES ANALÍTICAS ENCONTRAM-SE NOS RESUMOS - EXTRATO MENSAL DE ROYALTIES DISPONÍVEIS EM SISTEMA AO FRANQUEADO **</p>
                                        </div>
                                    </GridContainer>
                                </div>
                            </div>

                        </CardBody>

                    </Card>
                </GridItem>
            </GridContainer>
        </div>

    );

}